import { pick } from 'lodash'

export const mapStateToProps = ({
  vendor: {
    currentVendor,

    aliasCreated: vendorAliasCreated,
    aliasUpdated: vendorAliasUpdated,
    aliasDeleted: vendorAliasDeleted,

    glCodeCreated: vendorGlCodeCreated,
    glCodeUpdated: vendorGlCodeUpdated,
    glCodeDeleted: vendorGlCodeDeleted,

    expenseCategoryCreated: vendorExpenseCategoryCreated,
    expenseCategoryUpdated: vendorExpenseCategoryUpdated,
    expenseCategoryDeleted: vendorExpenseCategoryDeleted,
  },
}) => ({
  currentVendor,

  vendorAliasCreated,
  vendorAliasUpdated,
  vendorAliasDeleted,

  vendorGlCodeCreated,
  vendorGlCodeUpdated,
  vendorGlCodeDeleted,

  vendorExpenseCategoryCreated,
  vendorExpenseCategoryUpdated,
  vendorExpenseCategoryDeleted,
})

export const handlers = (EVENTS) => ({
  creteVendorAlias:
    ({ trackEvent, currentVendor }) =>
    () => {
      const { name, fields } = EVENTS.CREATE_VENDOR_ALIAS
      trackEvent(name, pick(currentVendor, fields))
    },

  updateVendorAlias:
    ({ trackEvent, currentVendor }) =>
    () => {
      const { name, fields } = EVENTS.UPDATE_VENDOR_ALIAS
      trackEvent(name, pick(currentVendor, fields))
    },

  deleteVendorAlias:
    ({ trackEvent, currentVendor }) =>
    () => {
      const { name, fields } = EVENTS.DELETE_VENDOR_ALIAS
      trackEvent(name, pick(currentVendor, fields))
    },

  creteVendorGlCode:
    ({ trackEvent, currentVendor }) =>
    () => {
      const { name, fields } = EVENTS.CREATE_VENDOR_GL_CODE
      trackEvent(name, pick(currentVendor, fields))
    },

  updateVendorGlCode:
    ({ trackEvent, currentVendor }) =>
    () => {
      const { name, fields } = EVENTS.UPDATE_VENDOR_GL_CODE
      trackEvent(name, pick(currentVendor, fields))
    },

  deleteVendorGlCode:
    ({ trackEvent, currentVendor }) =>
    () => {
      const { name, fields } = EVENTS.DELETE_VENDOR_GL_CODE
      trackEvent(name, pick(currentVendor, fields))
    },

  creteVendorExpenseCategory:
    ({ trackEvent, currentVendor }) =>
    () => {
      const { name, fields } = EVENTS.CREATE_VENDOR_EXPENSE_CATEGORY
      trackEvent(name, pick(currentVendor, fields))
    },

  updateVendorExpenseCategory:
    ({ trackEvent, currentVendor }) =>
    () => {
      const { name, fields } = EVENTS.UPDATE_VENDOR_EXPENSE_CATEGORY
      trackEvent(name, pick(currentVendor, fields))
    },

  deleteVendorExpenseCategory:
    ({ trackEvent, currentVendor }) =>
    () => {
      const { name, fields } = EVENTS.DELETE_VENDOR_EXPENSE_CATEGORY
      trackEvent(name, pick(currentVendor, fields))
    },
})

export const onComponentDidUpdate = (prevProps, props) => {
  const {
    vendorAliasCreated,
    vendorAliasUpdated,
    vendorAliasDeleted,

    vendorGlCodeCreated,
    vendorGlCodeUpdated,
    vendorGlCodeDeleted,

    vendorExpenseCategoryCreated,
    vendorExpenseCategoryUpdated,
    vendorExpenseCategoryDeleted,
  } = props

  if (vendorAliasCreated !== prevProps.vendorAliasCreated && vendorAliasCreated) {
    props.creteVendorAlias()
  }
  if (vendorAliasUpdated !== prevProps.vendorAliasUpdated && vendorAliasUpdated) {
    props.updateVendorAlias()
  }
  if (vendorAliasDeleted !== prevProps.vendorAliasDeleted && vendorAliasDeleted) {
    props.deleteVendorAlias()
  }

  if (vendorGlCodeCreated !== prevProps.vendorGlCodeCreated && vendorGlCodeCreated) {
    props.creteVendorGlCode()
  }
  if (vendorGlCodeUpdated !== prevProps.vendorGlCodeUpdated && vendorGlCodeUpdated) {
    props.updateVendorGlCode()
  }
  if (vendorGlCodeDeleted !== prevProps.vendorGlCodeDeleted && vendorGlCodeDeleted) {
    props.deleteVendorGlCode()
  }

  if (
    vendorExpenseCategoryCreated !== prevProps.vendorExpenseCategoryCreated &&
    vendorExpenseCategoryCreated
  ) {
    props.creteVendorExpenseCategory()
  }
  if (
    vendorExpenseCategoryUpdated !== prevProps.vendorExpenseCategoryUpdated &&
    vendorExpenseCategoryUpdated
  ) {
    props.updateVendorExpenseCategory()
  }
  if (
    vendorExpenseCategoryDeleted !== prevProps.vendorExpenseCategoryDeleted &&
    vendorExpenseCategoryDeleted
  ) {
    props.deleteVendorExpenseCategory()
  }
}
